import { render, staticRenderFns } from "./UserUpcomingReservations.vue?vue&type=template&id=f8a15d14&scoped=true"
import script from "./UserUpcomingReservations.vue?vue&type=script&lang=js"
export * from "./UserUpcomingReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a15d14",
  null
  
)

export default component.exports